import {
  Component,
  OnInit,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import * as Chart from 'chart.js';
import { BehaviorSubject, Subject, combineLatest, ReplaySubject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ma-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent implements AfterViewInit, OnDestroy {
  @ViewChild('chartEl') chartEl: ElementRef<HTMLCanvasElement>;

  data$ = new ReplaySubject<{ data: Chart.ChartPoint[]; labels: string[] }>();
  @Input() set data(data: { data: Chart.ChartPoint[]; labels: string[] }) {
    this.data$.next(data);
  }

  @Input() type = 'line';
  @Input() label = '';
  @Input() isLoading: boolean;

  chart: Chart;

  onDestroy$ = new Subject();

  constructor(private readonly elementRef: ElementRef) {
    this.data$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((chartData) => {
          if (this.chart && chartData) {
            const { data, labels } = chartData;
            this.chart.data.labels = labels;
            this.chart.data.datasets = [
              {
                borderColor: '#1B7A91',
                label: this.label,
                data,
              },
            ];
            this.chart.update();
          }
        }),
      )
      .subscribe();
  }

  initChart() {
    this.chart = new Chart(this.chartEl.nativeElement, {
      type: 'line',
      data: {
        labels: [],
        datasets: [],
      },
    });
  }

  ngAfterViewInit() {
    this.initChart();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
